import React, { useEffect, useState, useRef } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DownloadIcon from "@mui/icons-material/Download";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Link } from "react-router-dom";
import DailyWorkEntry from "./DailyWorkEntry";
import TrackTime from "./TrackTime";
import AttendenceSetting from "./AttendenceSetting";
import { saveAs } from "file-saver";
import FineModel from "./FineModel";

export default function SettingPanel({ attendance, departments }) {
  const [isOpen, setIsOpen] = useState(false);
  const [openDailyWork, setOpenDailyWork] = useState(false);
  const [openTrackTime, setOpenTrackTime] = useState(false);
  const [applyFine, setApplyFine] = useState(false);
  const [openAttendenceSetting, setOpenAttendenceSetting] = useState(false);
  const [exportFormat, setExportFormat] = useState("CSV");
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const toggleSwitch = () => {
    setIsOn(!isOn);
  };
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [isOn, setIsOn] = useState(false);
  useEffect(() => {
    console.log(openDailyWork);
  }, [openDailyWork]);
  useEffect(() => {
    console.log(openTrackTime);
  }, [openTrackTime]);
  useEffect(() => {
    console.log(openAttendenceSetting);
  }, [openAttendenceSetting]);

  const onOpenModal = () => setOpenDailyWork(true);
  // const onOpenModal = () => setOpenTrackTime(true);
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
  };

  

  const exportCSV = () => {
    const headers = [
      "Department",
      "Total Staff",
      "Present",
      "Absent",
      "Approval Pending",
      "Paid Leave",
      "OverTime Hours",
      "Fine Hours",
    ];

    const csvData = [
      headers.join(","), // Add headers to the first row
      ...departments?.map((department) => {
        // Filter records by department ID
        const departmentRecords = attendance?.filter(
          (a) => a?.punchRecord?.staff?.departmentId === department?.id
        );

        const totalStaff = departmentRecords.length;
        const present = departmentRecords.filter(
          (r) => r?.punchRecord?.status === "PRESENT"
        ).length;
        const absent = departmentRecords.filter(
          (r) => r?.punchRecord?.status === "ABSENT"
        ).length;
        const approvalPending = departmentRecords.filter(
          (r) => !r?.punchRecord?.isApproved
        ).length;
        const paidLeave = departmentRecords.filter(
          (r) => r?.punchRecord?.status === "PAID_LEAVE"
        ).length;
        const overtimeHours = departmentRecords
          .map((r) => r?.punchRecord?.Overtime || 0)
          .reduce((acc, hours) => acc + hours, 0);
        const fineHours = departmentRecords
          .map((r) => r?.punchRecord?.fine || 0)
          .reduce((acc, hours) => acc + hours, 0);

        // Create a CSV row for this department
        return [
          department.department_name,
          totalStaff,
          present,
          absent,
          approvalPending,
          paidLeave,
          overtimeHours,
          fineHours,
        ].join(",");
      }),
    ].join("\n");

    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "Daily_Report.csv");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        !openDailyWork &&
        !openTrackTime &&
        !openAttendenceSetting
      ) {
        setIsOpen(false); // Close the dropdown if clicked outside and no modal is open
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDailyWork, openTrackTime, openAttendenceSetting]);

  return (
    <div className="relative text-right">
      <DailyWorkEntry
        isOpen={openDailyWork}
        setIsOpen={setOpenDailyWork} // Pass state and handler as props
      />
      <TrackTime open={openTrackTime} setOpen={setOpenTrackTime} />
      <AttendenceSetting
        open={openAttendenceSetting}
        setOpen={setOpenAttendenceSetting}
      />
      <FineModel open={applyFine} setOpen={setApplyFine}/>

      <div className="flex flex-wrap justify-between items-center gap-2 md:gap-5 p-[10px]">
        <div className="flex gap-[10px] summary-bold">
          <h1 className="font-semibold whitespace-nowrap summary-attend">
            Attendence Summary
          </h1>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            className="mr-[10px] font-semibold text-[#8e54c2] text-[14px]"
            to="#"
          >
            Unprocessed Logs <FilterListIcon className="icon-filter" />
          </button>
          <button
            className="mr-[10px] font-semibold text-[#8e54c2] text-[14px]"
            to="#"
            onClick={exportCSV}
          >
            Daily Report <DownloadIcon className="icon-filter" />
          </button>
          <button
            ref={buttonRef}
            onClick={() => {
              setIsOpen((prev) => !prev);
            }}
            className="mr-[10px] font-semibold text-[#8e54c2] text-[14px]"
            to="#"
          >
            Setting <SettingsIcon className="icon-filter" />
          </button>
        </div>
      </div>

      {/* Dropdown Content */}
      {isOpen && (
        <div
          ref={dropdownRef}
          className="right-[24px] z-10 absolute bg-white shadow-lg mt-2 border rounded-md w-[500px] panel-attendence"
           >
          <ul>
            <li className="p[0]">
              <Link
                onClick={() => setOpenAttendenceSetting(true)}
                className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer"
              >
                <span className="text-[14px] text-gray-700 md:text-[16px]">
                  Attendance
                </span>
                <div className="flex items-center text-gray-500">
                  <span className="text-[14px] md:text-[16px]">
                    Selfie & Location
                  </span>
                  <KeyboardArrowRightIcon className="ml-2 w-5 h-5" />
                </div>
              </Link>
            </li>
            <li className="p-[0]">
              <Link
                to="#"
                onClick={() => setOpenDailyWork(true)}
                className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer"
              >
                <span
                  className="text-[14px] text-gray-700 md:text-[16px]"
                  // Open the modal on click
                >
                  Daily Work Entry
                </span>

                <div className="flex items-center text-gray-500">
                  <span className="text-[14px] md:text-[16px]">
                    Enabled (11 Staffs)
                  </span>
                  <KeyboardArrowRightIcon className="ml-2 w-5 h-5" />
                </div>
              </Link>
            </li>
            <li className="p-[0]">
              <div className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer">
                <span className="text-[14px] text-gray-700 md:text-[16px]">
                  Weekly Holiday
                </span>
                <div className="flex items-center text-gray-500">
                  <span className="text-[14px] md:text-[16px]">Select</span>
                  <KeyboardArrowRightIcon className="ml-2 w-5 h-5" />
                </div>
              </div>
            </li>
            <li className="p-[0]">
              <div className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer">
                <span className="text-[14px] text-gray-700 md:text-[16px]">
                  Send SMS to Staff
                </span>
                <div
                  className={`relative w-14 h-8 flex items-center rounded-full p-1 cursor-pointer ${
                    isOn ? "bg-[#27004a]" : "bg-gray-300"
                  }`}
                  onClick={toggleSwitch}
                >
                  <div
                    className={`bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out ${
                      isOn ? "translate-x-6" : "translate-x-0"
                    }`}
                  ></div>
                </div>
              </div>
            </li>
            <li className="p-[0]">
              <Link
                onClick={() => setOpenTrackTime(true)}
                className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer"
              >
                <span className="text-[14px] text-gray-700 md:text-[16px]">
                  Track In/Out Time
                </span>
                <span className="text-[14px] text-gray-500 md:text-[16px]">
                  Enabled
                </span>
              </Link>
            </li>
            <li className="p-[0]">
              <Link  onClick={() => setApplyFine(true)}  className="flex justify-between items-center hover:bg-gray-50 p-4 cursor-pointer">
                <span className="text-[14px] text-gray-700 md:text-[16px]">
                  Apply Fine & Overtime
                </span>
                <div className="flex items-center text-gray-500">
                   <KeyboardArrowRightIcon className="ml-2 w-5 h-5" />
                </div>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
